export default __webpack_public_path__ + "static/media/gnl10.8cc465e1.jpg";